import script from "./ThumbPick.vue?vue&type=script&setup=true&lang=js"
export * from "./ThumbPick.vue?vue&type=script&setup=true&lang=js"

import "./ThumbPick.vue?vue&type=style&index=0&id=d7b2aeb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7b2aeb0"]])

export default __exports__